import { useHover } from "@mantine/hooks";
import { MouseEventHandler } from "react";

import { colors } from "#app/theme/v1/colors";
import { Icon, IconName } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { Flex } from "#shared/view/components/Flex";

import { Text } from "../components/Text";
import { UnstyledButton } from "./UnstyledButton";

export const TextButton = ({
  children,
  onClick,
  color = colors.gray[4],
  disabled,
  size,
  icon,
}: {
  children: React.ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  color?: string;
  disabled?: boolean;
  size?: string;
  icon?: IconName;
}) => {
  const { hovered, ref: buttonRef } = useHover();

  return (
    <UnstyledButton onClick={onClick} disabled={disabled}>
      <Flex gap="xs" align="center">
        <Text ref={buttonRef} td={hovered && !disabled ? "underline" : ""} c={color} size={size}>
          {children}
        </Text>
        {icon && (
          <ActionIcon>
            <Icon name={icon} size={14} color={color} />
          </ActionIcon>
        )}
      </Flex>
    </UnstyledButton>
  );
};
